var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.64,3.27H18.55V1.09H16.37V3.27H7.63V1.09H5.45V3.27H4.36A2.17,2.17,0,0,0,2.19,5.45V20.73a2.18,2.18,0,0,0,2.18,2.18H19.64a2.19,2.19,0,0,0,2.18-2.18V5.45A2.19,2.19,0,0,0,19.64,3.27Zm0,17.46H4.36v-12H19.64Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.5 19.14 6.68 15.32 8.22 13.78 10.5 16.05 16 10.55 17.55 12.09 10.5 19.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingIcon);
export default __webpack_public_path__ + "static/media/scheduling_icon.65a86579834fd739c33870864ea43a53.svg";
export { ForwardRef as ReactComponent };